import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { ComponentBaseProps } from "models/propTypes/basePropTypes";
//#endregion
//#region components
import { Grid, Skeleton } from "@mui/material";
import lazyWithReload from "utils/lazyWithReload";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const BannerImageLazy = lazyWithReload(() => import("./allCompletedBannerImage"));

const AllCompletedStateWidget: React.FC<ComponentBaseProps> = (props) => {
  return (
    <Grid
      item
      container
      wrap={"nowrap"}
      className={clsx(cssExports.stateBannerContainer, cssExports.allCompletedBannerContainer, props.className)}
      direction="row"
    >
      <Grid item className={cssExports.bannerImgContainer}>
        <React.Suspense fallback={<Skeleton width={148} style={{ background: "transparent" }}></Skeleton>}>
          <BannerImageLazy />
        </React.Suspense>
      </Grid>
      <Grid item xs container alignItems="center">
        <Grid item container spacing={0} direction="column">
          <Grid item className={cssExports.bannerHeaderText}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.GoodJob)}
          </Grid>
          <Grid item className={cssExports.bannerDescription}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AllCompletedText)}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AllCompletedStateWidget;
